'use client'

import { useDateTime } from '../../hooks'

export const ToDateTime = ({
  date,
  showSeconds,
}: {
  date: Date
  showSeconds?: boolean
}) => {
  const { toDateTime } = useDateTime()
  return toDateTime(date, showSeconds)
}

export const ToDate = ({ date }: { date: Date }) => {
  const { toDate } = useDateTime()
  return toDate(date)
}

export const ToTime = ({ date }: { date: Date }) => {
  const { toTime } = useDateTime()
  return toTime(date)
}

export const ConvertDateTimeToMonth = ({ time }: { time: string | number }) => {
  const { convertDateTimeToMonth } = useDateTime()
  return convertDateTimeToMonth(time)
}

export const ConvertDateTimeToDay = ({ time }: { time: string | number }) => {
  const { convertDateTimeToDay } = useDateTime()
  return convertDateTimeToDay(time)
}
